import { withTheme } from 'styled-components';
import { Description, ForgetText, Form, FormButton, Title, Wrapper } from '../style';
import Tabs from '../../../components/Tabs';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import Input from '../../../components/Input';
import { observer } from 'mobx-react-lite';
import authStore from '../../../store/auth';

const tabs = [
  { title: 'Sign In', value: 'login' },
  { title: 'Register', value: 'signup' }
];

const Login = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabValue = useMemo(() => location.pathname.replace('/', ''), [location]);

  const onTabChange = tab => navigate('/' + tab.value);

  const onSubmit = e => {
    e.preventDefault();
    authStore.authorize({ name: 'Otabek', surname: 'Nosirov' }, '12312312');
  };

  return (
    <Wrapper>
      <Title>Welcome to DATOX</Title>
      <Description>
        Datox seamlessly integrates data from various sources, including databases, APIs, and
        external applications
      </Description>
      <Tabs tabs={tabs} value={tabValue} onClick={onTabChange} />
      <Form onSubmit={onSubmit}>
        <Input label="Email" placeholder="Type your email" />
        <Input label="Password" placeholder="Type your password" type="password" />
        <ForgetText to="/forget">Forget Password?</ForgetText>
        <FormButton maxWidth={true}>Continue with Email</FormButton>
      </Form>
    </Wrapper>
  );
};

export default observer(withTheme(Login));
